import React, { useState } from "react";
import { Share2, Copy, Check, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// One-tap distribution: copy/share the creator's public storefront link (/c/:id) with an OG preview.
export default function ShareStorefrontCard({ userId }) {
  const [copied, setCopied] = useState(false);
  if (!userId) return null;
  const url = `${window.location.origin}/c/${userId}`;

  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: "My GameView Studio storefront", url }); return; } catch { /* fall through to copy */ }
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Storefront link copied — paste it anywhere!");
      setTimeout(() => setCopied(false), 2000);
    } catch { toast.error("Couldn't copy — long-press the link to copy it."); }
  };

  return (
    <div className="mb-6 rounded-2xl border border-[hsl(var(--border))] bg-gradient-to-br from-[hsl(var(--primary))]/10 to-fuchsia-500/5 p-4 flex flex-col sm:flex-row items-center gap-4" data-testid="share-storefront-card">
      <img src={`${BACKEND}/api/og/creator/${userId}/image.png`} alt="Storefront preview" loading="lazy"
        className="w-40 rounded-xl border border-[hsl(var(--border))] shrink-0 bg-[hsl(var(--muted))]" style={{ aspectRatio: "1200/630" }} />
      <div className="min-w-0 flex-1 text-center sm:text-left">
        <div className="font-display font-bold flex items-center gap-2 justify-center sm:justify-start">
          <Share2 className="w-4 h-4 text-[hsl(var(--primary))]" /> Share your storefront
        </div>
        <p className="text-sm text-[hsl(var(--muted-foreground))] mt-0.5">
          One public link with all your games, followers & tip jar. Post it on socials to grow your audience.
        </p>
        <div className="mt-3 flex items-center gap-2 flex-wrap justify-center sm:justify-start">
          <code className="text-xs px-2 py-1.5 rounded-lg bg-[hsl(var(--muted))] truncate max-w-[240px]" data-testid="storefront-link">{url}</code>
          <Button size="sm" onClick={share} className="rounded-full" data-testid="copy-storefront-btn">
            {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />} {copied ? "Copied" : "Copy link"}
          </Button>
          <Button size="sm" variant="outline" onClick={() => window.open(url, "_blank", "noopener")} className="rounded-full" data-testid="preview-storefront-btn">
            <ExternalLink className="w-3.5 h-3.5" /> Preview
          </Button>
        </div>
      </div>
    </div>
  );
}
